import * as React from "react";
const Svg41RatioIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 5, y: 14, width: 22, height: 4, rx: 1, stroke: "#00528A", strokeWidth: 2 }));
export { Svg41RatioIcon as ReactComponent };
